import axios, { AxiosError } from "axios";
import config from "../Constants/Config";
import {SliderDTO} from "../Models/DTOs/SliderDTO";

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL;

export async function GetFeaturedSlider(sliderId: number, abortController: AbortController) {
    const slider = await axios
        .get(`${WEB_API_URL}v1${config.sliders}/${sliderId}`, {
            signal: abortController.signal,
        })
        .then((result) => result.data as SliderDTO)
        .catch((error: AxiosError) => {
            console.log("GetFeaturedSlider");
            throw error;
        });

    return slider;
}
